<template>
    <div>
        <v-card>

            <v-card-title class="btn_otro">
                <v-row class="d-flex justify-space-between py-0 pl-4">
                    {{this.datosSesionAprendizaje.id ? 'EDITAR ' : 'CREAR '}} SESIÓN DE APRENDIZAJE
                    <v-btn fab dark x-small class="btn_style3" @click="$emit('close')"><v-icon dark>fa-times</v-icon></v-btn>
                </v-row>
            </v-card-title>

            <v-card-text>
                <v-row>
                    <v-col cols="12" class="text-center py-6">
                        <span class="font-weight-bold">Nivel: </span> <span class="font-weight-black pr-3">{{datosTema.desc_nivel}}</span>
                        <span class="font-weight-bold">Grado: </span> <span class="font-weight-black pr-3">{{datosTema.desc_grado}}</span>
                        <span class="font-weight-bold">Area: </span> <span class="font-weight-black pr-3">{{datosTema.desc_area}}</span>
                        <span class="font-weight-bold">Curso: </span> <span class="font-weight-black pr-3">{{datosTema.desc_curso}}</span> <br>
                        <span class="font-weight-bold">Unidad: </span> <span class="font-weight-black pr-3">{{datosTema.nombre_clase }}</span>
                        <span class="font-weight-bold">Tema: </span> <span class="font-weight-black pr-3">{{ datosTema.nombre_tema }}</span>
                    </v-col>
                </v-row>
                <v-stepper v-model="stepper">
                    <v-stepper-header>
                        <v-stepper-step
                            editable
                            step="1"
                        >
                            Datos generales y aprendizaje
                        </v-stepper-step>
                
                
                        <v-stepper-step
                            editable
                            step="2"
                        >
                            Secuencia didáctica <br>
                            Referencia bibliográficas
                        </v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-content step="1">
                        <v-form ref="formDatosGenerales" lazy-validation>
                            <v-row> 
                                <v-col cols="12" lg="3">
                                    <v-text-field value="Sessión 1/1" readonly></v-text-field>
                                </v-col>
                                <v-col cols="12" lg="3">
                                    <v-text-field label="Docente" disabled></v-text-field>
                                </v-col>
                                <v-col cols="12" lg="3">
                                    <v-text-field label="Tutor" disabled></v-text-field>
                                </v-col>
                                <v-col cols="12" lg="3">
                                    <v-text-field label="Fecha de aplicación" disabled></v-text-field>
                                </v-col>

                                <v-col cols="12" lg="2">
                                    <v-text-field label="Tiempo de aplicación" :rules="[rul.required]" 
                                    v-model="datosSesionAprendizaje.tiempo_aplicacion"></v-text-field>
                                </v-col>
                                <v-col cols="12" lg="5">
                                    <v-textarea rows="1" label="Enfoques Transversales" :rules="[rul.required]"
                                    v-model="datosSesionAprendizaje.enfoques_transversales"></v-textarea>
                                </v-col>
                                <v-col cols="12" lg="5">
                                    <v-textarea rows="1" label="Objetivos" :rules="[rul.required]"
                                    v-model="datosSesionAprendizaje.objetivos"></v-textarea>
                                </v-col>
                            </v-row>
                            <!-- Competencias -->
                            <v-row>
                                <v-col cols="12" v-for="(item01,index01) in listCompetencias" :key="index01" class="py-0">
            
                                    <v-row v-if="index01==0" class="btn_otro white--text py-3 head-competencias font-weight-bold">
            
                                        <v-col cols="5" md="5" class="py-0 px-4">
                                            <span class="d-flex justify-start">COMPETENCIAS </span>
                                        </v-col>
            
                                        <v-col cols="5" md="7" class="py-0">
                                            <span>DESCRIPCIÓN </span>
                                        </v-col>
                                    </v-row>
            
                                    <!--  Item01  RENGLONES DE COMPETENCIAS -->
                                    <v-row  v-for="(item02,index02) in item01.competencias" :key="index02">
                                        <v-col cols="12" md="5" class="py-0 my-0">
            
                                            <v-checkbox  :value="item02.id_competencia"
                                                @change="EventCompetencia($event, index01, item02.id, index02)" class="mx-2">
                                            </v-checkbox>
                                        </v-col>
            
                                        <v-col cols="12" md="7" class="py-0 d-flex justify-start align-center" >
                                            <div style=" text-align:justify;"><i class="fas fa-chevron-right fa-lg ico_competencia"></i> {{item02.descripcion}}</div>
                                        </v-col>
                                                        
                                        <!--  CAPACIADADES INSERT  v-model= "checkCapacidad" -->
                                        <v-col cols="12" v-if="item02.capacidades">
            
                                            <v-row>
            
                                                <v-col cols="12" class="blue white--text py-0 head-capacidades">
                                                    <v-row>
                                                        <v-col cols="11"  offset="1" class="px-2">
                                                            <span class="d-flex justify-start    font-weight-bold">CAPACIDADES</span>
                                                        </v-col>                                        
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-col>
            
            
                                        <!-- Imten03 DETALLE DE CAPACIADADES -->
            
            
                                        <v-col cols="12"  v-if="item02.capacidades">
            
                                            <v-row v-for="(item03,index03) in item02.capacidades" :key="index03">
            
                                                <v-col cols="12" md="4" offset="1" class="py-0 my-0" style="padding:50px;">
            
                                            <!--  event, indexPrincipal, id_competencia_area, indexComp, indexCap  -->
                                                    <v-checkbox   :value="item03.id" class="mx-2"
                                                        @change="EventCapacidad($event, index01, item03.id, index02, index03)">
                                                    </v-checkbox>
                                                </v-col>
            
                                                <v-col cols="12" md="7" class="py-0 d-flex justify-start">
                                                    <div style=" text-align:justify;"><i class="fas fa-caret-right fa-lg ico_capacidad"></i> {{item03.descripcion}} </div>
                                                </v-col>
            
                                            
            
                                                <!--
                                                    /////////////////////////////////
                                                    DESEMPEÑO O INIDICADORES
                                                    /////////////////////////////////
                                                -->
            
                                                <v-col cols="12" v-if="item03.indicador">
            
                                                    <v-row>
            
                                                        <v-col cols="12" class="light-blue white--text py-0 head-desempenios">
                                                            <v-row>
                                                                <v-col cols="10"  offset="2" class="px-2">
                                                                    <span class="d-flex justify-start  font-weight-bold">DESEMPEÑOS</span>
                                                                </v-col>                                        
                                                            </v-row>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
            
            
                                                <!-- Imten03 DETALLE DE INDICADORES O DESEMPEÑO -->
            
                                                <v-col cols="12" v-if="item03.indicador">
            
                                                    <v-row v-for="(item04,index04) in item03.indicador" :key="index04">
            
                                                        <v-col cols="12" md="3" offset="2" class="py-0 my-0" style="padding:50px;">
            
                                                            <!--  event Indicadores o Desompeños,  indexPrincipal, id_competencia_area, indexComp, indexCap  -->
                                                            <v-checkbox   :value="item03.id" class="mx-2"
                                                                @change="EventIndicador($event,  item02, item03, item04)">
                                                            </v-checkbox>
                                                        </v-col>
            
                                                        <v-col cols="12" md="7" class="py-0 d-flex justify-start">
                                                            <div style=" text-align:justify;"><i class="fas fa-angle-double-right fa-lg ico_indicador"></i> {{item04.descripcion}} </div>
                                                        </v-col>
            
                                                    
                                                    </v-row>
            
                                                </v-col>
            
            
                                            </v-row>
            
            
            
                                        </v-col>
            
            
                            
                                        <!-- FIN DE CAPACIDADES -->
                                    </v-row>
                                </v-col>
            
                            </v-row>
                        </v-form>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                        <!-- boton crear secuencia didáctica -->
                        <v-row class="pt-0">
                            <v-col class="d-flex justify-end pt-0">
                                <v-col cols="auto pr-0">
                                    <v-btn class="btn_block_style2" :disabled="!datosSesionAprendizaje.id" dark  @click="CrearSecuencia">CREAR SECUENCIA DIDÁCTICA</v-btn>
                                </v-col>
                            </v-col>
                        </v-row>
                        <v-simple-table height="auto">
                            <template v-slot:default>
                              <thead>
                                    <tr class="secondary black--text">
                                        <th class="text-left">SECUENCIA DIDÁCTICA</th>
                                        <th class="text-left">PROCESOS PEDÁGOGICOS</th>
                                        <th class="text-left">ACTIVIDADES</th>
                                        <th class="text-left">RECURSOS</th>
                                        <th class="text-left">EDITAR</th>
                                        <th class="text-left">ELIMINAR</th>
                                    </tr>
                              </thead>
                              <tbody>
                                    <tr v-for="(secuencia, indexSecuencia) in datosSesionAprendizaje.secuenciasDidacticas" :key="indexSecuencia">
                                        <td>
                                            <span>
                                                {{secuencia.secuencia.nombre}}
                                            </span>
                                        </td>
                                        <td>
                                            <div v-for="(proceso, indexProceso) in secuencia.procesosPedagogicos" :key="indexProceso">
                                                {{proceso.nombre}}
                                            </div>
                                        </td>
                                        <td>
                                            <v-tooltip bottom color="#1b1b1b">
                                                <template v-slot:activator="{ on }">
                                                    <v-btn v-on="on" class="primary px-0 mx-0" fab x-small>
                                                        <v-icon>fa-eye</v-icon>
                                                    </v-btn>
                                                </template>
                                                <div class="py-0 my-0" v-for="(proceso, indexProceso) in secuencia.procesosPedagogicos" :key="indexProceso">
                                                    <div v-for="(actividad, indexActividad) in proceso.actividades" :key="`Actividad${indexActividad}`">
                                                        {{actividad.nombre}}<br>
                                                    </div>
                                                </div>
                                            </v-tooltip>
                                        </td>
                                        <td>
                                            <div class="py-0 my-0" v-for="(proceso, indexProceso) in secuencia.procesosPedagogicos" :key="indexProceso">
                                                <div v-for="(recurso, indexRecurso) in proceso.recursos" :key="`Recurso${indexRecurso}`">
                                                    {{recurso.nombre}}<br>
                                                </div>
                                            </div>
                                        </td>
                                        <td class="text-left">
                                            <v-btn class="mx-2 pl-1" fab dark x-small color="warning" title="Editar" @click="EditSecuencia(secuencia)"><v-icon small >fa-edit</v-icon></v-btn>
                                        </td>
                                        <td>
                                            <v-btn class="btn_eliminar mx-2" fab x-small color="error" title="Eliminar" @click="ShowModalDelete(secuencia)">
                                                <v-icon>fa-trash-alt</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                    </v-stepper-content>
                </v-stepper>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer> 
                <v-btn v-if="stepper == 1" class="primary" @click="SaveDatosGenerales">Guardar</v-btn>
            </v-card-actions>
            <!-- {{ listIndicadores }} <br>
            {{ datosSesionAprendizaje.indicadores }} -->
        </v-card>

        <!--modal para agregar secuencia didáctica -->
        <v-dialog v-model="modal_secuencia" persistent scrollable max-width="80%">
            <secuenciaDidactica @close="CerrarModalSecuencia" @post-save="CerrarModalSecuenciaPostSave" :datos="datosSecuencia"></secuenciaDidactica>
        </v-dialog>

        <confirm
            @aceptar="DeleteSecuencia"
            @cancelar="CloseConfirm"
            :title="desc_confirm"
            :active="dialog_confirm"
        />
    </div>
</template>

<script>
    import axios from '@/helpers/axios'
    import { mapMutations, mapGetters, mapActions} from 'vuex'
    import secuenciaDidactica from "./componentes/secuenciaDidactica.vue";
    export default {
        name:'SesionAprendizaje',
        components:{
            secuenciaDidactica
        },
        props:{
            datosSesionAprendizaje: {
                type: Object,
                default: Object
            },
            datosTema: {
                type: Object,
                default: Object
            }
        },
        
        data: () => ({
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            paramComponente:{ 'id_submodulo':141, "id_modulo": 5}, //sud_modulo y modulo

            datoLogin: sessionStorage, // variables de sesion del usuario
            ////////////////////////////////////////////////////////

            //validaciones de formulario
            rul: {
                required: value => !!value || 'Campo Requerido',
                inputReq: value => !!value || 'Campo Requerido',
                selectReq: value => !!value || 'Debe seleccionar un campo de la lista',
                email: value => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) || 'El correo es incorrecto',
                min4: v => (v || '').length >= 4 || 'Mínimo 4 caracteres',
                min6: v => (v || '').length >= 6 || 'Mínimo 6 caracteres',
                min8: v => (v || '').length >= 8 || 'Mínimo 8 caracteres',
                max10: v => (v || '').length <= 10 || 'Máximo 10 caracteres',
                max11: v => (v || '').length <= 11 || 'Máximo 11 caracteres',
                max12: v => (v || '').length <= 12 || 'Máximo 12 caracteres',
                max20: v => (v || '').length <= 20 || 'Máximo 20 caracteres',
                max30: v => (v || '').length <= 30 || 'Máximo 30 caracteres',
                max50: v => (v || '').length <= 50 || 'Máximo 50 caracteres',
                max60: v => (v || '').length <= 60 || 'Máximo 60 caracteres',
                max100: v => (v || '').length <= 100 || 'Máximo 100 caracteres',
                max150: v => (v || '').length <= 150 || 'Máximo 150 caracteres',
            },
            stepper: 1,
            listCompetencias: [],
            listIndicadores: [],
            datosSecuencia:{},
            modal_secuencia:false,

            // modal confirmacion
            id_delete:null,
            dialog_confirm:false,
            desc_confirm: '',
            //////////////////////////////////
        }),

        computed: {
            ...mapGetters('login', [ 'componenteEvento']),
        },

        mounted (){
            this.stepper = 1;
            if(this.datosSesionAprendizaje.indicadores)
                this.listIndicadores = this.datosSesionAprendizaje.indicadores;
            this.GetAllCompetencias()
        },

        created () {
            this.stepper = 1;
            this.actualizarParamentro();
        },

        methods: {
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
             //----- Validar accesos por perfil ------------
            ...mapActions('login',['parametroComponente'] ),

            actualizarParamentro() {
                this.parametroComponente(this.paramComponente)
            },

            //  ------- MENSAJE DE SISTEMA  --------
            ...mapMutations('mensajeSis', ['setEnviarMens']),
            ////////////////////////////////////////////////////////


            async GetAllCompetencias(){
                this.listCompetencias   = [];
                const params = {
                    id_colegio: this.datoLogin.id_colegio,
                    id_nivel: this.datosTema.id_nivel_grado, 
                    id_grado: this.datosTema.id_grado_tema,  
                    id_area: this.datosTema.id_area,
                }
                
                try{
                    let resp = await axios.post(`/manager/competenciasArea/call/`, params )
                    // let resp = await axios.post(`/administrativo/competencia/cs/all/`,params )
                    this.listCompetencias =  resp.data;
                }  catch(error){
                    this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                }
            },

              // CHECK DE COMPETENCIAS EVENTO
            //listar las  CAPACIDADES a dar click en una Competencia
            async EventCompetencia(event, indexPrincipal, id_competencia_area, indexComp, recargar=false){
                // event: si esta chequeado o NO la competencia (true, false)
                // indexPrincipal:  posicion del elemento del index Principal
                // id_competencia_area:  campo unico de la tabla competencia
                // indexComp: posicion del elemento de la compentencia

                console.log("EVENT", event)
                if (recargar) {
                    this.listCompetencias[indexPrincipal].competencias[indexComp].capacidades = []
                }

                if(event){ 
                    try{

                        var resp   = await axios.get(`/manager/capacidad/gall/${id_competencia_area}`)
                        // let resp = await axios.get(`/administrativo/capacidad/listAllCapacidad/${id_competencia_area}`)
                        console.log(resp.data)
                        if(resp.data.length == 0){
                            this.listCompetencias[indexPrincipal].competencias[indexComp].capacidades = []
                        }else{
                            this.listCompetencias[indexPrincipal].competencias[indexComp].capacidades = resp.data
                        }
                    } catch(error){
                        this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                    }
                    //check es false
                } else{

                    this.listCompetencias[indexPrincipal].competencias[indexComp].capacidades = null;
                }
            },

            //listar las INDICADORES O DESEMPEÑO  a dar click en una Capacidad
            async EventCapacidad(event, indexPrincipal, id_capacidad, indexComp, indexCap){
                // event si esta checkqueado o NO la capacidad
                console.log("datosSesionAprendizaje de event Capacidad")
                console.log("EVENTO",event)
                console.log("indexPrincipal: "+indexPrincipal)
                console.log("id_capacidad: "+id_capacidad)
                console.log("indesxComp: "+indexComp)
                console.log("indesCap: "+indexCap)


                if(event){

                    try{
                        // Listar los Indicadores o Desempeños
               
                        var resp   = await axios.get(`/manager/indicador/gall/${id_capacidad}`)
                        /*     
                        let params = {
                            // id_curriculo: this.filtro.id_curriculo, 
                            id_competencia_area:null, 
                            id_mgr_capacidad:null, 
                            id_capacidad
                        }
                        var resp   = await axios.post(`/administrativo/indicador/listInd/`,params) 
                        */

                        if(resp.data.length == 0){
                             this.com[indexPrincipal].competencias[indexComp].capacidades[indexCap].indicador = []
                        }

                        else{
                            this.listCompetencias[indexPrincipal].competencias[indexComp].capacidades[indexCap].indicador = resp.data
                        }
                    }  catch(error){
                        this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                        this.listCompetencias[indexPrincipal].competencias[indexComp].capacidades[indexCap].indicador  = []
                    }

                // Limpia los Indicadores Seleccionado
                }  else{
                    this.listCompetencias[indexPrincipal].competencias[indexComp].capacidades[indexCap].indicador  = null
                }
            },
            
            async EventIndicador(event, competencia, capacidades, indicador){
                // this.setEnviarMens({tipo:"W", mensaje: `HOLA Desempeño EDITAR`, tiempo:null})

                // SELECCIONADO
                if(event){
                    console.log(`CHECK TRUE, EVENTO: ${event}`)
                    // FALTA DEFINIR EL ORIGEN
                    let items = {
                                    id_competencia: competencia.id, 
                                    id_capacidad  : capacidades.id, 
                                    id_indicador: indicador.id,
                                    origin : indicador.origen
                                    }
                    this.listIndicadores.push(items)

                }else{
                    console.log(`CHECK FALSE, EVENTO: ${event}`)
                    let index = this.listIndicadores.findIndex(item => item.id_indicador === indicador.id);
                    console.log("INDEX ELEMENTO A BORRAR ", index)                    
                    this.listIndicadores.splice(index, 1)
                }

                /*
                    console.log("EVENTO",event)
                    console.log("COMPETENCIA",competencia)
                    console.log("CAPACIDADES",capacidades)
                    console.log("INDICADOR",indicador)
                    // console.log("INDICADOR",indicador)

                */
            },

            async CrearSecuencia(){
                this.datosSecuencia = {
                    id_sesion_aprendizaje: this.datosSesionAprendizaje.id, 
                    procesosPedagogicos: [{nombre: "", tiempo: 1, actividades: [{nombre: ""}], recursos: [{nombre: ""}]}]
                }
                this.modal_secuencia = true
            },

            async EditSecuencia(secuencia){
                if(secuencia.procesosPedagogicos.length == 0)
                    secuencia.procesosPedagogicos = [{nombre: "", tiempo: 1, actividades: [{nombre: ""}], recursos: [{nombre: ""}]}]
                this.datosSecuencia = secuencia
                this.modal_secuencia = true
            },

            async DeleteSecuencia(){
                try {
                    var res = await axios.delete(`/manager/sesionAprendizaje/secuencia/${this.id_delete}/`);
                    if(res.data.messageT == 'S'){
                        this.dialog_confirm = false;
                        let index = this.datosSesionAprendizaje.secuenciasDidacticas.findIndex(s => s.id == this.id_delete);   
                        this.datosSesionAprendizaje.secuenciasDidacticas.splice(index, 1);
                    }                                         
                    this.setEnviarMens({ tipo: res.data.messageT, mensaje: res.data.message, tiempo: 6000}) 
                } catch (error) {
                    this.setEnviarMens({ tipo: res.data.messageT, mensaje: res.data.message, tiempo: null })
                }
            },

            CerrarModalSecuencia(){
                this.modal_secuencia = false;
            },

            CerrarModalSecuenciaPostSave(){
                this.modal_secuencia = false;
                this.UpdateSecuenciasDidacticas()
            },

            async UpdateSecuenciasDidacticas(){
                try{
                    let resp = await axios.get(`/manager/sesionAprendizaje/tema/${this.datosSesionAprendizaje.id_tema}/`);
                    this.datosSesionAprendizaje.secuenciasDidacticas = resp.data.secuenciasDidacticas
                }  catch(error){
                    console.log(error);
                }
            },

            async SaveDatosGenerales(){
                if (this.$refs.formDatosGenerales.validate()) {
                    if(this.listIndicadores.length==0){
                        this.setEnviarMens({ tipo: "W", mensaje: `Dede de Seleccionar algún Desempeño para poder Guardar`, tiempo: 8000});
                        return false
                    }                       

                    try {
                        let res = {}
                        this.datosSesionAprendizaje.id_usuario =  this.datoLogin.id
                        const params = {
                            id_colegio: this.datoLogin.id_colegio, id_nivel: this.datosTema.id_nivel_grado, id_grado: this.datosTema.id_grado_tema, 
                            id_tema: this.datosTema.id_tema, id_area: this.datosTema.id_area, enfoques_transversales: this.datosSesionAprendizaje.enfoques_transversales, 
                            tiempo_aplicacion: this.datosSesionAprendizaje.tiempo_aplicacion, objetivos: this.datosSesionAprendizaje.objetivos, 
                            indicadores : this.listIndicadores
                        }   
                                        
                        if (this.datosSesionAprendizaje.id) {    
                            res = await axios.put(`/manager/sesionAprendizaje/${this.datosSesionAprendizaje.id}/`, params);                                            
                        } else {                        
                            res = await axios.post("/manager/sesionAprendizaje", params);          
                            if(res.data.messageT == "S"){
                                console.log('Sesion Aprendizaje:', res.data);
                                this.datosSesionAprendizaje.id = res.data.data.id;
                                this.stepper = 2;                       
                            }                  
                        }

                        this.setEnviarMens({ tipo: res.data.messageT, mensaje: res.data.message, tiempo: 6000}) 

                    } catch (error) {
                        console.log(error);
                        this.setEnviarMens({ tipo: "E", mensaje: `Error al guardar registro`, tiempo: null })
                    }
                }
            },

            CloseConfirm() {
                this.id_delete = 0;
                this.dialog_confirm = false;
            },

            async ShowModalDelete(secuencia) {
                this.id_delete = secuencia.id;
                this.desc_confirm = `¿Está seguro de eliminar este registro (${secuencia.secuencia.nombre} - ${secuencia.nombre})?`;
                this.dialog_confirm = true;
            },
        }
    }
</script>
